import { CustomPasswordInput } from "components/customs/form/CustomPasswordInput";
import { ConfirmationModal } from "components/modals/ConfirmationModal";
import { AlertMessage } from "components/notification/AlertMessage";
import { useAuthenticationActions } from "dataflow/billingPortal/actions/useAuthentication.actions";
import { getObjectPropertyValue, isStringEqual_caseSensitive, isStringTrimNotEmpty } from "functions";
import { useCustomSelector } from "hooks";
import React, { useState } from "react";

export default function useResetPassword(propsUserInfo) {
    const {
        resetPassword_requesting, resetPassword_status,
        resetPassword_errorMsg
    } = useCustomSelector("authentication");

    // States

    const [isModalVisible, setIsModalVisible] = useState(false);

    const [currentPwd, setCurrentPwd] = useState("");
    const [newPwd, setNewPwd] = useState("");
    const [confirmPwd, setConfirmPwd] = useState("");

    const [isFormSubmissionAttempted, setIsFormSubmissionAttempted] = useState(false);

    const [isResetPasswordAlertMsgVisible, setIsResetPasswordAlertMsgVisible] = useState(false);
    
    const { resetPassword } = useAuthenticationActions();

    function handleResetPasswordSubmission() {
        let userEmail = getObjectPropertyValue(propsUserInfo, "UserName", "");

        if (isStringTrimNotEmpty(userEmail) &&
            isStringTrimNotEmpty(currentPwd) &&
            isStringTrimNotEmpty(newPwd) &&
            isStringTrimNotEmpty(confirmPwd) &&
            isStringEqual_caseSensitive(newPwd, confirmPwd)) {
            
            let userInfo = {
                UserName: userEmail,
                OldPassword: currentPwd,
                NewPassword: confirmPwd
            };

            resetPassword(userInfo);    
        }

        setIsFormSubmissionAttempted(true);
    }

    let resetPwdModal = (
        <ConfirmationModal
            isModalVisible={isModalVisible}
            updateParentState={setIsModalVisible}

            className={"dashboardSidebar-resetPwdModal"}
            headerClassName={"dashboardSidebar-resetPwdModal-header"}

            description={"Reset Password"}
            input={(
                <>
                    {/* Alert Message */}
                    <AlertMessage
                        wrapperclassName={"dashboardSidebar-resetPwdModal-alertMsg"}
                        message={resetPassword_errorMsg}
                        isVisible={isResetPasswordAlertMsgVisible}
                        toggleVisibility={() => { setIsResetPasswordAlertMsgVisible(!isResetPasswordAlertMsgVisible); }}
                    />

                    {/* Current Password */}
                    <CustomPasswordInput
                        customInputClassName={"dashboardSidebar-resetPwdModal-currentPwd"}

                        password={currentPwd}
                        isFormSubmissionAttempted={isFormSubmissionAttempted}

                        handleValueChange={setCurrentPwd}
                        handleOnEnterPressed={handleResetPasswordSubmission}

                        options={{
                            inputLabel: "Current Password",
                            isLabelOptional: false,
                            isInputOptional: false
                        }}
                    />

                    {/* New Password */}
                    <CustomPasswordInput
                        customInputClassName={"dashboardSidebar-resetPwdModal-newPwd"}

                        password={newPwd}
                        isFormSubmissionAttempted={isFormSubmissionAttempted}

                        handleValueChange={setNewPwd}
                        handleOnEnterPressed={handleResetPasswordSubmission}

                        options={{
                            inputLabel: "New Password",
                            isLabelOptional: false,
                            isInputOptional: false
                        }}
                    />

                    {/* Confirm Password */}
                    <CustomPasswordInput
                        customInputClassName={"dashboardSidebar-resetPwdModal-confirmPwd"}

                        password={confirmPwd}
                        isFormSubmissionAttempted={isFormSubmissionAttempted}

                        handleValueChange={setConfirmPwd}
                        handleOnEnterPressed={handleResetPasswordSubmission}

                        options={{
                            inputLabel: "Confirm Password",
                            isLabelOptional: false,
                            isInputOptional: false,
                            customErrorValidation: (!isStringEqual_caseSensitive(newPwd, confirmPwd) && isFormSubmissionAttempted),
                            customErrorMsgDefault: "Invalid password"
                        }}
                    />
                </>
            )}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            handleOnConfirm={handleResetPasswordSubmission}
            isActionLoading={resetPassword_requesting}
            isConfirmSuccessful={resetPassword_status}
        />
    );


    return {
        setIsModalVisible,
        resetPwdModal
    }
}